import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tipo")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Categoria")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Centro de Custo")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Detalhamento")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-10 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_15 = ["onUpdate:modelValue", "disabled"]
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_18 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_19 = ["onClick", "disabled"]
const _hoisted_20 = ["onClick", "disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"15px","margin-bottom":"5px"}
}, null, -1)
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_25 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-8"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-8" }, null, -1)
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_tipo_detalhamento_titulo_financeiro = _resolveComponent("selecionar-tipo-detalhamento-titulo-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: " " }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        (_ctx.props.editavel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, (!_ctx.storeSistema.state.layoutMobile)]
      ]),
      (_ctx.computedDetalhamentos.length <= 0)
        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
            key: 0,
            mensagem: "Nenhum detalhamento adicionado ainda"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedDetalhamentos, (detalhamento, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ant-row ss-grade-personalizada-linha",
                key: index
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo",
                    class: "ss-margin-campos ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_detalhamento_titulo_financeiro, {
                        valor: _ctx.computedDetalhamentos[index].tipo,
                        "onUpdate:valor": ($event: any) => ((_ctx.computedDetalhamentos[index].tipo) = $event),
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["valor", "onUpdate:valor", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "Categoria",
                    class: "ss-margin-campos ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_categoria_plano_conta, {
                        codigoSelecionado: _ctx.computedDetalhamentos[index].codigoPlanoContaCategoria,
                        "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedDetalhamentos[index].codigoPlanoContaCategoria) = $event),
                        empresas: [_ctx.props.empresa],
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "Centro de Custo",
                    class: "ss-margin-campos ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_centro_custo, {
                        codigoSelecionado: _ctx.computedDetalhamentos[index].centroCusto.codigoCentroCusto,
                        "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedDetalhamentos[index].centroCusto.codigoCentroCusto) = $event)
                      }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição",
                    class: "ss-margin-campos ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.computedDetalhamentos[index].descricao) = $event),
                        disabled: !_ctx.props.editavel
                      }, null, 8, _hoisted_15), [
                        [_vModelText, _ctx.computedDetalhamentos[index].descricao]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Valor",
                    class: "ss-margin-campos ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.computedDetalhamentos[index].tipo === 3)
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 0,
                            valor: _ctx.computedDetalhamentos[index].valor,
                            "onUpdate:valor": [
                              ($event: any) => ((_ctx.computedDetalhamentos[index].valor) = $event),
                              _cache[0] || (_cache[0] = ($event: any) => (_ctx.obterTotalDetalhado()))
                            ],
                            percentual: true,
                            disabled: !_ctx.props.editavel
                          }, null, 8, ["valor", "onUpdate:valor", "disabled"]))
                        : (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 1,
                            valor: _ctx.computedDetalhamentos[index].valor,
                            "onUpdate:valor": [
                              ($event: any) => ((_ctx.computedDetalhamentos[index].valor) = $event),
                              _cache[1] || (_cache[1] = ($event: any) => (_ctx.obterTotalDetalhado()))
                            ],
                            monetario: true,
                            disabled: !_ctx.props.editavel
                          }, null, 8, ["valor", "onUpdate:valor", "disabled"]))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    label: " ",
                    class: "ss-label-show-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                          title: "Copiar Detalhamento",
                          onClick: ($event: any) => (_ctx.copiarDetalhamento(index)),
                          disabled: !_ctx.props.editavel
                        }, [
                          _createVNode(_component_icone, { nome: "copiar" })
                        ], 8, _hoisted_19),
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                          title: "Excluir Detalhamento",
                          onClick: ($event: any) => (_ctx.removerDetalhamento(index)),
                          disabled: !_ctx.props.editavel
                        }, [
                          _createVNode(_component_icone, { nome: "excluir" })
                        ], 8, _hoisted_20)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ])),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        (_ctx.props.editavel)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria ss-tamanho-completo",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarDetalhamento()))
                }, "Novo detalhamento")
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_ctx.computedDetalhamentos.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removerTodos()))
                    }, "Remover Todos"))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_25)),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_a_form_item, {
            label: "Total Detalhamento",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.obterTotalDetalhado(),
                monetario: true,
                permitirValorNegativo: true,
                disabled: true
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_a_form_item, {
            label: "Qtde Itens",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                style: {"text-align":"right"},
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedDetalhamentos.length) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.computedDetalhamentos.length]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _withDirectives(_createVNode(_component_a_alert, {
        message: _ctx.apresenaMensagemDiferencaDetalhamento(),
        type: "warning",
        "show-icon": ""
      }, null, 8, ["message"]), [
        [_vShow, (_ctx.props.editavel && _ctx.props.valor > 0 && _ctx.computedTotalDetalhado !== _ctx.props.valor && _ctx.computedDetalhamentos.length > 0)]
      ])
    ]),
    _: 1
  }))
}